import { consola } from 'consola'
import { apiProduct, type ResolvedBranchProduct } from '../api'

const logger = consola.withTag('branch-alias')

/**
 * Резолв карточек чужого филиала в карточки указанного (группы «одно блюдо»).
 *
 * Общий кирпич для избранного, «вы заказывали» и повтора заказа: дедуп id,
 * один вызов API и ЕДИНАЯ политика отказа — сбой сети не пробрасывается,
 * резолв это улучшение: без него потребитель просто продолжает со своими id
 * (пустой ответ = «ничего не подменяем», как было до групп блюд).
 */
export async function resolveBranchAliases(
  foreignIds: ReadonlyArray<string>,
  branchId: number,
): Promise<ResolvedBranchProduct[]> {
  const unique = [...new Set(foreignIds.filter(Boolean))]
  if (unique.length === 0) return []

  try {
    return await apiProduct.resolveForBranch(unique, branchId)
  } catch (error) {
    logger.warn('resolve-for-branch не удался — карточки чужого филиала останутся как есть:', error)
    return []
  }
}
